import React from "react";
import ReactModal from "react-modal";
import { axiospost } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Form, Formik } from "formik";
import { ms_applicant_referee } from "@v2/validators";
import ErrorMessage from "../../components/ErrorMessage";
import { useQueryClient } from "@tanstack/react-query";

const BtnReferee = ({ modules }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const queryClient = useQueryClient();

  const _save = async (values) => {
    try {
      const firstname = values?.firstname;
      const middlename = values?.middlename;
      const lastname = values?.lastname;
      const emailaddress = values?.emailaddress;
      const phonenumber = values?.phonenumber;
      const homeaddress = values?.homeaddress;
      const req = await axiospost("ms_applicant_referee", {
        firstname,
        middlename,
        lastname,
        emailaddress,
        phonenumber,
        homeaddress,
      });
      if (req.status !== 200) {
        throw new Error(req?.message);
      }
      const { data } = req;
      if (data && data.type === "success") {
        const { message, type } = data;
        swal(type, message);
        queryClient.invalidateQueries({ queryKey: ["listOfReferees"] });
        _close();
      } else {
        throw new Error(data.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };

  const _close = () => {
    setshowmodal(false);
  };
  const _show = () => {
    setshowmodal(true);
  };
  const customStyles = {
    overlay: {
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      marginTop: "15vh",
      right: "auto",
      zIndex: 1001,
      bottom: "auto",
    },
  };

  return (
    <div>
      <ReactModal isOpen={showmodal} style={customStyles} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center">Parents and Guadians Form</h5>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={{
                  firstname: modules ? modules?.firstname : "",
                  middlename: modules ? modules?.middlename : "",
                  lastname: modules ? modules?.lastname : "",
                  emailaddress: modules ? modules?.emailaddress : "",
                  phonenumber: modules ? modules?.phonenumber : "",
                  homeaddress: modules ? modules?.homeaddress : "",
                }}
                validationSchema={ms_applicant_referee.createrefereerule}
                initialTouched={{ zip: true }}
                onSubmit={_save}
              >
                {({ isSubmitting, touched, errors }) => (
                  <Form className="my-4">
                    <div className="row">
                      <div className="col-md-4">
                        <ErrorMessage
                          name={"firstname"}
                          label="First name"
                          type="text"
                          key={`firstname`}
                          errors={errors?.firstname}
                          touched={touched?.firstname}
                        />
                      </div>
                      <div className="col-md-4">
                        <ErrorMessage name={"middlename"} label="Middle name" type="text" key={`middlename`} />
                      </div>
                      <div className="col-md-4">
                        <ErrorMessage
                          name={"lastname"}
                          label="Last name"
                          type="text"
                          key={`lastname`}
                          errors={errors?.lastname}
                          touched={touched?.lastname}
                        />
                      </div>
                      <div className="col-md-6">
                        <ErrorMessage name={"emailaddress"} label="Email Address" type="email" key={`error_emailaddress`} />
                      </div>
                      <div className="col-md-6">
                        <ErrorMessage
                          name={"phonenumber"}
                          label="Phone Number (+2348xxxxxxxxx)"
                          type="text"
                          key={`error_phonenumber`}
                          errors={errors?.phonenumber}
                          touched={touched?.phonenumber}
                        />
                      </div>

                      <div className="col-md-12">
                        <ErrorMessage
                          name={"homeaddress"}
                          label="Home Address of Referee"
                          type="text"
                          key={`error_homeaddress`}
                          errors={errors?.homeaddress}
                          touched={touched?.homeaddress}
                        />
                      </div>
                      <div className="text-right">
                        <button disabled={isSubmitting} type="submit" className="btn btn-primary  btn-lg mr-1">
                          {!isSubmitting ? "Save changes" : "Please wait..."}
                        </button>
                        <button type="button" className="btn btn-danger btn-lg" onClick={_close}>
                          Close
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ReactModal>

      <div>
        {!modules && (
          <div
            style={{
              position: "fixed",
              right: "50px",
              bottom: "50px",
            }}
          >
            <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
              <i className="ti-plus"></i>
            </button>
          </div>
        )}
      </div>
      <div>
        {modules && (
          <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
            <i className="ti-pencil"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default BtnReferee;
